---
markset: 0
theme:
  preset: technical
  accent: "#2563eb"
---

# Tidewater

{.lead}
A short tour. Every block below is Markset, and every one of them is still readable
if you delete the renderer.

> [!NOTE]
> Callouts are GitHub's syntax, unchanged. Markset did not invent a spelling for this.

:::metrics
| Signal | Now | Change |
|---|---|---|
| Uptime | 99.95% | +0.02 |
| Median latency | 84 ms | -11 |
| Open incidents | 2 | -1 |
:::

:::grid{cols=2}
- ### Semantic

  You name intent. The theme decides what it looks like.

- ### Closed

  Eight constructs, and the list does not grow. An unknown name is an error.
:::
